import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import api from 'services/api';

class DicionarioDadosFornecedor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dadosDicionario: [],
        };
    };

    async componentDidMount() {
        let dicionarioDadosFornecedor = sessionStorage.getItem('dicionarioDadosFornecedor');

        if (dicionarioDadosFornecedor == null) {
            const result = await api.get(`/whatsapp/dicionariofornecedor`);
            dicionarioDadosFornecedor = result.data;
            sessionStorage.setItem('dicionarioDadosFornecedor', JSON.stringify(dicionarioDadosFornecedor));
        } else {
            dicionarioDadosFornecedor = JSON.parse(dicionarioDadosFornecedor);
            console.log(dicionarioDadosFornecedor);
        }

        this.setState({ dadosDicionario: dicionarioDadosFornecedor });
    };

    render() {
        const { dadosDicionario } = this.state;

        return (
            <div>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ padding: '6px 16px' }}><strong>Campo</strong></TableCell>
                                <TableCell style={{ padding: '6px 16px' }}><strong>Descrição</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dadosDicionario.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell style={{ padding: '6px 16px' }}>{item.campo}</TableCell>
                                    <TableCell style={{ padding: '6px 16px' }}>{item.descricao}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}

export default (DicionarioDadosFornecedor);